import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("ac_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("ac_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
    // Run once on mount to restore session from token; deps intentionally omitted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("ac_token", res.data.access_token);
    setUser(res.data.user);
    return res.data.user;
  };

  const applySession = ({ access_token, user: nextUser }) => {
    localStorage.setItem("ac_token", access_token);
    setUser(nextUser);
  };

  const logout = () => {
    localStorage.removeItem("ac_token");
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, loading, login, logout, applySession }),
    [user, loading],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
